import { Grid, Typography } from "@mui/material";
import { ReactNode } from "react";

import styles from "../../../../assets/styles/componentStyles/chatbotStyles/chatbotIntegration/chatbotIntegrationPopup.module.scss";

interface ConfigurationHeaderProps {
    title: string;
    subTitle: string;
    subTitleLabel: string;
    icon: string;
}

const ConfigurationHeader = (props: ConfigurationHeaderProps) => {

    const { title, subTitle, subTitleLabel, icon } = props;

    return (

        <Grid container className={styles.configurationHeaderContainer}>

            <Grid item className={styles.configurationHeaderIcon}>
                <img src={icon} alt={title} />
            </Grid>

            <Grid item>

                <Typography className={styles.configurationHeaderTitle}>
                    {title}
                </Typography>

                <Typography className={styles.configurationHeaderId}>
                    {subTitleLabel}: {subTitle}
                </Typography>

            </Grid>

        </Grid>

    );

};

export default ConfigurationHeader;